/* Tissire visual fixes, Aug 2026.
   On product pages, if the Judge.me widget opens on an empty
   "Product reviews (0)" tab, switch to the store reviews tab.
   Most Tissire pieces are one-offs, so per-product review counts
   are almost always zero; store reviews are the real social proof. */
(function () {
  var main = document.querySelector('main[data-template]');
  if (!main || (main.dataset.template || '').indexOf('product') !== 0) return;

  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var tabs = document.querySelectorAll('button.jdgm-tab');
    var prod = null;
    var store = null;
    tabs.forEach(function (el) {
      var t = (el.textContent || '').trim();
      var m = t.match(/\((\d+)\)\s*$/);
      if (!m) return;
      var lower = t.toLowerCase();
      if (lower.indexOf('store') !== -1 || lower.indexOf('boutique') !== -1) {
        store = { el: el, n: parseInt(m[1], 10) };
      } else if (lower.indexOf('product') !== -1 || lower.indexOf('produit') !== -1) {
        prod = { el: el, n: parseInt(m[1], 10) };
      }
    });
    if (prod && store) {
      clearInterval(timer);
      if (prod.n === 0 && store.n > 0) store.el.click();
    } else if (tries >= 60) {
      clearInterval(timer);
    }
  }, 500);
})();
